// extracted by mini-css-extract-plugin
module.exports = {"peopleTag":"styles_peopleTag__2uh8e","peopleTitle":"styles_peopleTitle__15Cw-","peopleAvatar":"styles_peopleAvatar__jbbfr"};